/*
THIS COMPONENT IS INCLUDED IN FORM-EDIT REVIEW PAGE
 -----------------------------------------*/
let ReviewAnswers = (function () {

    let listenClickCopyBuffer = function () {
        let answerLink = $('#get_answer_link');
        answerLink.click(function() {
            let url = "/communication/reviews/" + answerLink.data('id') + "/get_link";
            getReviewLink(url);
        });

        function getReviewLink(url){
            $.ajax({
                url: url,
                type: 'GET',
                success: (data) => {
                    $("#answer_link").text(data);
                }
            });
        }
    };

    let init = function () {
        listenClickCopyBuffer();
    };

    return {
        init
    };
})();

export default ReviewAnswers;
